import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { updateExpenseApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const updateExpense = createAsyncThunk('updateExpense', async (payload) => {
  return await updateExpenseApi(payload);
});

const updateExpenseSlice = createSlice({
  name: 'updateExpense', // Unique Name
  initialState,
  reducers: {
    updateExpenseReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateExpense.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(updateExpense.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(updateExpense.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { updateExpenseReset } = updateExpenseSlice.actions;

export default updateExpenseSlice.reducer;
